import { useLocale } from "@jti/app-context/useLocale";
import { replaceInterpolation } from "@jti/fe-common";
import { formatWithIntl } from "@jti/format-price";

import { DiscountDisclaimerView } from "../DiscountDisclaimerView";
import { useDiscountDisclaimer } from "../hooks/useDiscountDisclaimer";

export const DiscountDisclaimerContainer = () => {
  const locale = useLocale();
  const {
    minimumPayableAmount,
    warningMessageTemplate,
    disclaimerMessageTemplate,
    shouldShowWarning,
    shouldShowDisclaimer,
  } = useDiscountDisclaimer();

  if (!shouldShowWarning && !shouldShowDisclaimer) {
    return null;
  }

  const formattedMinimumPayableAmount = minimumPayableAmount
    ? `<span style="direction: ltr;">${formatWithIntl({ ...minimumPayableAmount, locale })}</span>`
    : "";

  const warningMessage =
    shouldShowWarning && warningMessageTemplate
      ? replaceInterpolation(warningMessageTemplate, [formattedMinimumPayableAmount])
      : undefined;

  const disclaimerMessage = shouldShowDisclaimer && disclaimerMessageTemplate ? disclaimerMessageTemplate : undefined;

  return <DiscountDisclaimerView warningMessage={warningMessage} disclaimerMessage={disclaimerMessage} />;
};
